import Http from '../Http'
import { IQuery } from '../interfaces/Query'
import { IToken } from '../interfaces/Token'
import { Routes } from '../routes'

export default class Delivery extends Http {
  public async fee(token: IToken, params: IQuery = {}): Promise<any> {
    return (await this.spreeResponse(
      'get',
      Routes.deliveryFeePath(),
      token,
      params,
    )) as any
  }

  public async free_ship(token: IToken, params: IQuery = {}): Promise<any> {
    return (await this.spreeResponse(
      'get',
      Routes.deliveryFreeShipAmountPath(),
      token,
      params,
    )) as any
  }
}
